// @flow
export const withInheritQueryParam = (url: string, inherit?: boolean) => {
  if (!inherit) {
    return url;
  }

  const separator = url.includes('?') ? '&' : '?';

  return `${url}${separator}inheritance=true`;
};

export const withVisibilityQueryParam = (url: string, visibility?: boolean) => {
  if (!visibility) {
    return url;
  }

  const separator = url.includes('?') ? '&' : '?';

  return `${url}${separator}visibility=true`;
};
